/* eslint-disable @typescript-eslint/no-redeclare */
import React, { FC } from 'react';
import { theme } from '@mtsbank/ui-kit';
import { useTouchDevice } from '../../../useTouchDevice';
import { ControlsWrapper, NavControl } from './styled';
const controlsPositions = {
  top: 'top',
  bottom: 'bottom'
} as const;
export type ControlSize = 'sm' | 'md' | 'lg' | 'xl';
const controlSizeMap = {
  sm: theme.sizes.greater.sm,
  md: theme.sizes.greater.md,
  lg: theme.sizes.greater.lg,
  xl: theme.sizes.greater.xl
};
type Controls = {
  controlsPosition: keyof typeof controlsPositions;
  prevHandler: (event: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => void;
  nextHandler: (event: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => void;
  variant?: 'default' | 'premiumBanking';
  controlSize?: ControlSize;
  controlsPadding?: number;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
};
export const Controls: FC<Controls> = ({
  controlsPosition,
  prevHandler,
  nextHandler,
  variant = 'default',
  controlSize,
  controlsPadding,
  prevDisabled,
  nextDisabled
}) => {
  const isTop = controlsPosition === controlsPositions.top;
  const isBottom = controlsPosition === controlsPositions.bottom;
  const size = controlSizeMap[controlSize] || (isTop ? theme.sizes.greater.md : theme.sizes.greater.lg);
  const {
    isTouchDevice
  } = useTouchDevice(true);
  const topSpace = !isTop ? 0 : controlsPadding || theme.spacings.md;
  const bottomSpace = !isBottom ? 0 : controlsPadding || theme.spacings.md;

  // const timePeriod = 8000

  // const [timeLeft, setTimeLeft] = useState(timePeriod)

  // const svgRef = useRef(null)

  // useEffect(() => {
  //   if (timePeriod) {
  //     let timer: NodeJS.Timeout

  //     if (timeLeft > 0) {
  //       timer = setInterval(() => {
  //         setTimeLeft((prevTime) => prevTime - 1)
  //       }, 1000)
  //     }

  //     if (timeLeft === timePeriod) {
  //       svgRef.current.classList.remove('restart-animation')
  //       void svgRef.current.offsetWidth
  //       svgRef.current.classList.add('restart-animation')
  //       console.log(svgRef.current.classList, timePeriod, timeLeft)
  //     }

  //     if (timeLeft === 0) {
  //       // if (currentSlide + 1 < sliderQuantity) {
  //       //   nextHandler(currentSlide + 1)
  //       // } else {
  //       //   nextHandler(0)
  //       // }

  //       timer = setInterval(() => {
  //         setTimeLeft(timePeriod)
  //       }, 1000)
  //     }

  //     return () => clearInterval(timer)
  //   }
  // }, [timeLeft])

  return <ControlsWrapper hidden={isTouchDevice} top={topSpace} bottom={bottomSpace} right={controlsPadding && controlsPadding} onClick={e => e.stopPropagation()}>
      <NavControl size={size} onClick={prevHandler} onKeyDown={prevHandler} variant={variant} disabled={prevDisabled}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_5691_3190)">
            <path d="M15 5.01246C15 4.11226 13.9234 3.66144 13.2938 4.29798L10.1984 7.4273C8.06612 9.58289 7 10.6607 7 12C7 13.3393 8.06612 14.4171 10.1984 16.5727L13.2938 19.702C13.9234 20.3386 15 19.8877 15 18.9875C15 18.7196 14.8947 18.4625 14.7073 18.2731L11.6118 15.1437C10.5058 14.0255 9.82141 13.3276 9.38882 12.7544C8.99838 12.2371 8.99883 12.0565 8.99897 12.0028L8.99897 12L8.99897 11.9973C8.99883 11.9435 8.99838 11.7629 9.38882 11.2456C9.8214 10.6724 10.5058 9.97446 11.6118 8.85627L14.7073 5.72695C14.8947 5.53745 15 5.28044 15 5.01246Z" fill="#747796" />
          </g>
          <defs>
            <clipPath id="clip0_5691_3190">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </NavControl>
      <NavControl size={size} onClick={nextHandler} onKeyDown={nextHandler} variant={variant} disabled={nextDisabled}>
        {/* <Border ref={svgRef} className="restart-animation" timer={timePeriod}>
          <svg width="44" height="44">
            <rect
              className="circle"
              x="1"
              y="1"
              rx="8"
              ry="8"
              width="42"
              height="42"
              stroke="black"
              fill="transparent"
              strokeWidth="2"
            />
          </svg>
         </Border> */}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_5691_5145)">
            <path d="M9 5.01246C9 4.11226 10.0766 3.66144 10.7062 4.29798L13.8016 7.4273C15.9339 9.58289 17 10.6607 17 12C17 13.3393 15.9339 14.4171 13.8016 16.5727L10.7062 19.702C10.0766 20.3386 9 19.8877 9 18.9875C9 18.7196 9.1053 18.4625 9.29274 18.2731L12.3882 15.1437C13.4942 14.0255 14.1786 13.3276 14.6112 12.7544C15.0016 12.2371 15.0012 12.0565 15.001 12.0028L15.001 12L15.001 11.9973C15.0012 11.9435 15.0016 11.7629 14.6112 11.2456C14.1786 10.6724 13.4942 9.97446 12.3882 8.85627L9.29274 5.72695C9.1053 5.53745 9 5.28044 9 5.01246Z" fill="#747796" />
          </g>
          <defs>
            <clipPath id="clip0_5691_5145">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </NavControl>
    </ControlsWrapper>;
};

// export const Border = styled.div<{ timer: number }>`
//   @keyframes circletimer {
//     0% {
//       stroke-dashoffset: 500;
//       stroke-dasharray: 500;
//     }
//     100% {
//       stroke-dashoffset: 0;
//       stroke-dasharray: 500;
//     }
//   }

//   > svg {
//     background-color: transparent;
//     position: absolute;
//     bottom: 0px;
//     right: 0px;
//     width: 100%;
//     transform: rotateZ(0deg);
//   }
//   .circle {
//     stroke: rgba(188, 0, 84, 1);
//     stroke-width: 2;
//     fill: transparent;
//     stroke-dashoffset: 500;
//     stroke-dasharray: 0;
//     animation: 8s circletimer linear;
//   }

//   &.restart-animation > svg > circle {
//     -webkit-animation: ${({ timer }) => `circletimer ${timer * 4}s`};
//     -moz-animation: ${({ timer }) => `circletimer ${timer * 4}s`};
//     -o-animation: ${({ timer }) => `circletimer ${timer * 4}s`};
//   }
// `